module.exports = __webpack_public_path__ + "static/media/votercard.2dc498be.png";